// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3fgDH","label":"Category_label__qRwF9","content":"Category_content__2iZwi","header":"Category_header__2lc9e","location":"Category_location__nepaW"};